import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Select from 'react-select';

const PartyNameField = ({ limitSelectOptions }) => {
  return (
    <Field name="party_name" parse={({ value }) => value}>
      {({ input }) => (
        <Fragment>
          <label>Party Name</label>
          <Select {...input} clearable={false} options={limitSelectOptions} className="form-select" />
        </Fragment>
      )}
    </Field>
  );
};

PartyNameField.propTypes = {
  limitSelectOptions: PropTypes.array.isRequired,
};

export default PartyNameField;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/fields/PartyNameField.jsx